import * as classNames from 'classnames';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { SVG } from '../../../Utils/SVG';
/* TODO: Use LinkTile directly? */
import { IndexTile } from '../../../CategoryIndex/CategoryTiles/IndexTile';
import { Video } from '../../../../models';
import './style.css';
const nextIconURL = require('../../../../icons/thumbnailnext.svg');
const previousIconURL = require('../../../../icons/thumbnailback.svg');

export enum LinkedVideoType {
  Previous = 'previous',
  Next = 'next'
}

export interface LinkedVideoTileProps {
  getVideoUrl: (video: Video) => string;
  video?: Video;
  type: LinkedVideoType;
}

export interface LinkedVideoTileState {
  /* empty*/
}

export class LinkedVideoTile extends React.Component<
  LinkedVideoTileProps,
  LinkedVideoTileState
> {
  render() {
    const { getVideoUrl, type, video } = this.props;
    const iconURL =
      type === LinkedVideoType.Previous ? previousIconURL : nextIconURL;

    return video ? (
      <div
        className={classNames({
          'linked-video-tile': true,
          'linked-video-tile--premium': video.isPremium
        })}
      >
        <div className="linked-video-tile-inner">
          <IndexTile
            className="linked-video-tile-preview"
            image={video.poster}
            url={getVideoUrl(video)}
          >
            <div className="linked-video-tile-preview-content">
              <div className="linked-video-tile-preview-icon-wrapper">
                <SVG className="linked-video-tile-preview-icon" src={iconURL} />
              </div>
            </div>
          </IndexTile>
          {/*
            Prevent supplementary link gaining tab focus - this avoids the "bug" of having to
            tab twice through each tile, and also removes the need for using (non-IE compatible)
            :focus-within for styling when the link is focused
          */}
          <Link
            tabIndex={-1}
            className="linked-video-tile-content"
            to={getVideoUrl(video)}
          >
            <h3 className="linked-video-tile-header">
              {type === LinkedVideoType.Previous
                ? 'Previous Video'
                : 'Next Video'}
            </h3>
            <div className="linked-video-tile-title">{video.name}</div>
          </Link>
        </div>
      </div>
    ) : (
      <div className="linked-video-tile" />
    );
  }
}

export default LinkedVideoTile;



// WEBPACK FOOTER //
// ./src/app/components/Video/VideoDetailsBar/LinkedVideoTile/index.tsx